<template>
  <div class="diagnose">
    <el-dialog title="诊断详情" :modal="false" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <el-form :model="diagnoseFormData" label-width="100px">
        <el-form-item label="申请时间">
          <el-input v-model="diagnoseFormData.applyCodiagTime" disabled></el-input>
        </el-form-item>
        
        <el-form-item label="初步诊断">
          <el-input v-model="diagnoseFormData.applyDiagnosis" disabled></el-input>
        </el-form-item>

        <el-form-item label="发起人">
          <el-input v-model="diagnoseFormData.applyDoctorName" disabled></el-input>
        </el-form-item>

        <el-form-item label="发起机构">
          <el-input v-model="diagnoseFormData.applyHospital" disabled></el-input>
        </el-form-item>

        <el-form-item label="发起科室">
          <el-input v-model="diagnoseFormData.applyDeptName" disabled></el-input>
        </el-form-item>

        <el-form-item label="协诊机构">
          <el-input v-model="diagnoseFormData.codiagHospital" disabled></el-input>
        </el-form-item>

        <el-form-item label="协诊科室">
          <el-input v-model="diagnoseFormData.codiagDeptName" disabled></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      dialogVisible: false,
      diagnoseFormData: {},
      patientMsg: null,
      applyDiagnosisOptions: []
    };
  },
  methods: {
    // 初始化组件
    async init(value) {
      console.log("xiezhenxiangqing", value);
      this.diagnoseFormData = value;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep{
  .el-dialog {
    margin-top: 5vh !important;
  }
  .el-input.is-disabled .el-input__inner{
    color: #000;
  }

  .el-dialog__header {
    padding: 20px !important;
    padding-bottom: 10px !important;
  }
  
  .el-dialog__body {
    padding: 30px 20px !important;
  }
  
  .el-dialog__footer {
    padding: 20px !important;
    padding-top: 10px !important;
  }
}
</style>